import React from 'react'

interface BannerProps {
  text: string
  children: React.ReactNode
  className: string
}

export default function Banner({ text, children, className }: BannerProps) {
  return (
    <div className={className}>
      <div className='relative mb-4 w-auto overflow-hidden rounded-xl bg-gray-100 bg-opacity-75 shadow'>
        <div className='px-12 py-6 sm:p-6'>
          <div className='space-x-4 sm:flex sm:items-center sm:justify-between'>
            <div className='text-center text-sm text-gray-500 sm:max-w-xl'>
              {text}
            </div>

            <div className='mt-4 flex justify-center sm:mt-0 sm:shrink-0 sm:items-center'>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
